import { ProChat } from "@ant-design/pro-chat";
import ReactMarkdown from "react-markdown";
import { useTheme } from "antd-style";
import React, { useEffect, useState } from "react";
import { createDify } from "../../vercel-ai/dify";
import { getToken, getUserInfo } from "../../utils/cookies";
import { streamText } from "ai";
import { Typography } from "antd";
import { logoBase64 } from "../../utils/image";

export default function Chat() {
  const theme = useTheme();
  const [conversationId, setConversationId] = useState<string>("");
  return (
    <div
      style={{
        backgroundColor: theme.colorBgLayout,
        position: "relative",
        height: "95%",
        width: "100%",
      }}
    >
      <ProChat
        locale={"zh-HK"}
        style={{
          height: "100%",
          width: "100%",
        }}
        initialChats={[
          {
            content: "旺旺，我是工廠哈識奇，我可以怎麼協助您旺？",
            createAt: new Date().getTime(),
            id: "ZGxiX2p4",
            role: "assistant",
            updateAt: new Date().getTime(),
          },
        ]}
        chatItemRenderConfig={{
          avatarRender: (chatItem: any, defaultDom) => {
            if (chatItem.originData.role === "user") {
              return <></>;
            }
            return defaultDom;
          },
          contentRender: (chatItem: any, defaultDom: React.ReactNode) => {
            if (chatItem.hasOwnProperty("error") && chatItem.error) {
              return defaultDom;
            }
            if (chatItem.originData.role === "user") {
              return defaultDom;
            }
            if (chatItem.editing) {
              return defaultDom;
            }
            if (chatItem.loading && chatItem.message === "...") {
              return (
                <div id={chatItem["data-id"]}>
                  <Typography>
                    <DotDotDot />
                  </Typography>
                </div>
              );
            }
            return (
              <div id={chatItem["data-id"]}>
                <Typography>
                  <ReactMarkdown
                    children={chatItem.originData.content}
                    components={{
                      a: ({ node, ...props }) => {
                        if (isRelativePath(props.href as string)) {
                          return (
                            <React.Fragment>{props.children}</React.Fragment>
                          );
                        }
                        return (
                          <a {...props} target="_blank">
                            {props.children}
                          </a>
                        );
                      },
                      img: ({ node, ...props }) => (
                        <img
                          {...props}
                          alt={props.alt}
                          style={{ width: "100%" }}
                        />
                      ),
                    }}
                  />
                </Typography>
              </div>
            );
          },
        }}
        userMeta={{
          avatar: undefined,
          title: "User",
        }}
        assistantMeta={{ avatar: logoBase64(), title: "工廠哈識奇" }}
        placeholder={"請輸入訊息……"}
        markdownProps={{
          components: {
            a: ({ node, ...props }) => {
              if (isRelativePath(props.href as string)) {
                return <React.Fragment>{props.children}</React.Fragment>;
              }
              return (
                <a {...props} target="_blank">
                  {props.children}
                </a>
              );
            },
          },
        }}
        onResetMessage={async () => {
          setConversationId("");
        }}
        request={async (messages: Array<any>) => {
          const userInfo = getUserInfo();
          const difyProvider = createDify({
            baseURL: process.env.REACT_APP_PROXY_URL + "/proxy/v1",
            apiKey: getToken(),
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
            },
          });
          const queryParameter = await getQueryParameterValue();
          const stream = streamText({
            model: difyProvider("not-use", {
              userId:
                queryParameter.system + "-" + userInfo.email || "defaultUser",
              conversationId: conversationId,
              setConversationId: setConversationId,
              tenantId: userInfo.tenantId,
            }),
            // prompt: "hello world",
            messages: messages,
          });
          return stream.toTextStreamResponse();
        }}
      />
    </div>
  );
}

function isRelativePath(link: string): boolean {
  return !link.startsWith("http://") && !link.startsWith("https://");
}

function DotDotDot() {
  const [count, setCount] = useState(1);
  const [value, setValue] = useState("");
  useEffect(() => {
    setValue(".".repeat(count));
  }, [count]);
  useEffect(() => {
    const interval = setInterval(() => {
      setCount((val) => {
        if (val === 3) {
          return 1;
        }
        return val + 1;
      });
    }, 300);
    return () => clearInterval(interval);
  });
  return (
    <div key={"DotDotDot"} style={{ fontSize: "32px", fontWeight: "bold" }}>
      {value}
    </div>
  );
}

async function decodeBase64AndDecompress(base64String: string) {
  const binaryString = atob(base64String);

  const compressedUint8Array = Uint8Array.from(binaryString, (char) =>
    char.charCodeAt(0)
  );
  const decompressedStream = new Response(
    compressedUint8Array
  ).body?.pipeThrough(new DecompressionStream("gzip"));
  const decompressedArrayBuffer = await new Response(
    decompressedStream
  ).arrayBuffer();
  return new TextDecoder().decode(decompressedArrayBuffer);
}

async function getQueryParameterValue(): Promise<Record<string, any>> {
  const urlParams = new URLSearchParams(window.location.search);
  const inputs: Record<string, any> = {};

  for (const key of urlParams.keys()) {
    const value = urlParams.get(key);
    if (value) {
      inputs[key] = await decodeBase64AndDecompress(decodeURIComponent(value));
    }
  }
  return inputs;
}
